import Login from './Login';

export const routes = [
	{
		path: '/login',
		name: 'login',
		component: Login
	},
	{
		path: '/logout',
		name: 'logout',
		component: Login,
		props: { isLogout: true }
	}
];

export default routes;
